// extracted by mini-css-extract-plugin
var _1 = "ImportantNoticeModalStyle-module__label___OVTMR";
var _2 = "ImportantNoticeModalStyle-module__link___rIh9I";
export { _1 as "label", _2 as "link" }
